import { number, oneOfType, string } from 'prop-types';
import React from 'react';
import styles from './style';

const Icon = (props) => {
  const { src, size } = props;

  const containerIconStyles = { ...styles.containerIcon };
  if (size) {
    containerIconStyles.width = size;
    containerIconStyles.height = size;
  }

  return (
    <div style={containerIconStyles}>
      <img src={src} alt="" style={styles.icon} />
    </div>
  );
};

Icon.propTypes = {
  src: string,
  size: oneOfType([string, number]),
};

Icon.defaultProps = {
  src: '',
  size: 0,
};

export default Icon;
